import "./index.scss";
import { Badge } from "@wise-emotions/react-badge";
import { CardBlock } from "../components/CardBlock";
import { LiveInspectorData } from "types/types";
import React, { CSSProperties, ReactNode } from "react";
import cn from "classnames";

export type CardGenericProps = {
  title?: string;
  description?: ReactNode;
  image?: ReactNode;
  ctaLabel?: string;
  isCentered?: boolean;
  isPromo?: boolean;
  variant?:
    | "base-primary"
    | "base-secondary"
    | "base-tertiary"
    | "brand-primary"
    | "inverse-base-primary"
    | "gradient-navigation";
  customClass?: string;
  liveInspector?: LiveInspectorData;
};

const CardGeneric = ({
  title,
  description,
  image,
  ctaLabel,
  isCentered = false,
  isPromo = false,
  variant = "base-primary",
  customClass,
  liveInspector,
}: CardGenericProps) => {
  return (
    <div
      style={
        {
          "--card-generic-background":
            variant !== "gradient-navigation"
              ? `var(--background-${variant})`
              : undefined,
        } as CSSProperties
      }
      className={cn("card-generic", customClass, {
        "card-generic--gradient": variant === "gradient-navigation",
      })}
      {...liveInspector?.card}
    >
      {isPromo && (
        <div className="card-generic__badge">
          <Badge
            variant="iconAndLabel"
            theme="promo"
            contrast="high-contrast"
            label="Promo"
          />
        </div>
      )}
      {image && <div className="card-generic__image">{image}</div>}
      <CardBlock
        title={title}
        description={description}
        ctaLabel={ctaLabel}
        centered={isCentered}
        theme={
          variant === "brand-primary" || variant === "inverse-base-primary"
            ? "white"
            : "black"
        }
      />
    </div>
  );
};

CardGeneric.displayName = "CardGeneric";

export default CardGeneric;
